<template>
  <div id="app">
    <!-- 只有非admin路由才显示页眉和页脚 -->
    <HeaderComponent v-if="$route.path !== '/admin'" />
    <main id="main" :class="{ 'main-container': $route.path !== '/admin', 'admin-main-container': $route.path === '/admin' }">
      <router-view />
    </main>
    <FooterComponent v-if="$route.path !== '/admin'" />
  </div>
</template>

<script>
import HeaderComponent from './components/HeaderComponent.vue';
import FooterComponent from './components/FooterComponent.vue';

export default {
  name: 'App',
  components: {
    HeaderComponent,
    FooterComponent
  }
};
</script>

<style>
html, body, #app { height:100%; }
body { margin:0; }
#app { display:flex; flex-direction:column; min-height:100%; font-family:Avenir, Helvetica, Arial, sans-serif; -webkit-font-smoothing:antialiased; -moz-osx-font-smoothing:grayscale; color:#2c3e50; }
.main-container { flex:1 0 auto; display:block; }
/* 管理后台专用容器样式，允许Admin组件的flex布局完全控制 */
.admin-main-container { flex:1 0 auto; display:block; padding:0; margin:0; }
/* 防止内容较短时底部出现额外空白：去掉路由视图默认外边距由各页面自行控制 */

/* 移动端全局优化 */
@media (max-width: 768px) {
  html {
    font-size: 14px;
  }
  
  * {
    -webkit-tap-highlight-color: transparent;
  }
  
  button, a {
    cursor: pointer;
  }
}

@media (max-width: 480px) {
  html {
    font-size: 13px;
  }
}
</style>